// @flow

import React from "react";

import { LinkedFieldValues } from "./styles";
import { FieldValue } from "./Values/styles";
import LinkedRoom from "src/components/messages/Chat/Notification/LinkedRoom";

import type { RoomId } from "src/types";

type Props = {
  filteredOldValues: Array<RoomId>,
  disableTitleHyperlink: boolean,
};

const DiffOldConversationValues = ({
  filteredOldValues,
  disableTitleHyperlink,
}: Props) => {
  if (filteredOldValues.length === 0) {
    return null;
  }
  return (
    <FieldValue old>
      <LinkedFieldValues>
        {filteredOldValues.map((val, id) => (
          <LinkedRoom
            id={`${val}`}
            key={id}
            disableTitleHyperlink={disableTitleHyperlink}
          />
        ))}
      </LinkedFieldValues>
    </FieldValue>
  );
};

export default DiffOldConversationValues;
